import { useCallback, useState } from 'react';
import ZzzfunHeader from '@/components/feature/zzzfun-header';
import ZzzfunFooter from '@/components/feature/zzzfun-footer';
import ZzzfunDownloadModal from '@/components/feature/zzzfun-download-modal';
import { useZzzfunConfig } from '@/hooks/useZzzfunConfig';
import { useZzzfunTheme } from '@/hooks/useZzzfunTheme';
import { useZzzfunSeo } from '@/hooks/useZzzfunSeo';
import ZzzfunHero from './components/zzzfun-hero';
import ZzzfunFeatures from './components/zzzfun-features';
import ZzzfunScreenshots from './components/zzzfun-screenshots';
import ZzzfunAbout from './components/zzzfun-about';
import ZzzfunPlatforms from './components/zzzfun-platforms';
import ZzzfunStats from './components/zzzfun-stats';
import ZzzfunFaq from './components/zzzfun-faq';

export default function Home() {
  const config = useZzzfunConfig();
  const { theme, toggleTheme } = useZzzfunTheme();
  const [downloadOpen, setDownloadOpen] = useState(false);

  useZzzfunSeo({
    title: 'ZzzFun - 以兴趣为核心的番剧播放工具',
    description:
      'ZzzFun是以兴趣为核心的番剧播放工具，提供排行榜、新番时间表、分区发现与多端同步。ZzzFun官方APP免费下载，覆盖Android等四平台，高清流畅无弹窗追番。',
    keywords: 'ZzzFun',
    canonical: 'https://www.zzzfun.net/',
  });

  const openDownload = useCallback(() => setDownloadOpen(true), []);
  const closeDownload = useCallback(() => setDownloadOpen(false), []);

  return (
    <div className="min-h-screen bg-background-50">
      <ZzzfunHeader
        config={config}
        theme={theme}
        onToggleTheme={toggleTheme}
        onOpenDownload={openDownload}
      />
      {/* 固定页头占位块，高度与页头一致（移动端 h-16 / 桌面端 md:h-20） */}
      <div className="h-16 w-full md:h-20" aria-hidden="true" />
      <main>
        <ZzzfunHero onOpenDownload={openDownload} />
        <ZzzfunFeatures />
        <ZzzfunScreenshots />
        <ZzzfunAbout />
        <ZzzfunPlatforms />
        <ZzzfunStats />
        <ZzzfunFaq />
      </main>
      <ZzzfunFooter config={config} />
      <ZzzfunDownloadModal open={downloadOpen} onClose={closeDownload} config={config} />
    </div>
  );
}